import * as materialstyle from "@materialstyle/materialstyle";

import Alpine from "alpinejs";
import { inject } from "@vercel/analytics";

import { setAppHeight } from "./ui/setAppHeight";
import { initRipples } from "./ui/initRipples";

import "../css/app.scss"; // or app.css, depending on your file extension
import { initAlpineStores } from "./stores";
import { registerSW } from "./serviceWorker";

function onDomLoaded() {
  setAppHeight();
  initRipples();
}

document.addEventListener("DOMContentLoaded", onDomLoaded);
window.addEventListener("resize", setAppHeight);

document.addEventListener("alpine:init", initAlpineStores);
window.Alpine = Alpine;
Alpine.start();

registerSW();

// Initialize Vercel Web Analytics
inject();

